import { useEffect, useState } from 'react'
import { surChangementFile, synchroniser } from '../lib/sync'

/**
 * Indicateur permanent : combien d'éléments attendent d'être envoyés.
 * Sur un chantier sans réseau, c'est la seule preuve que rien n'est perdu.
 */
export function EtatSync() {
  const [restants, setRestants] = useState(0)
  const [enLigne, setEnLigne] = useState(navigator.onLine)

  useEffect(() => surChangementFile(setRestants), [])

  useEffect(() => {
    const maj = () => setEnLigne(navigator.onLine)
    window.addEventListener('online', maj)
    window.addEventListener('offline', maj)
    return () => {
      window.removeEventListener('online', maj)
      window.removeEventListener('offline', maj)
    }
  }, [])

  if (enLigne && restants === 0) return null

  const texte = !enLigne
    ? restants > 0
      ? `Hors ligne · ${restants} en attente`
      : 'Hors ligne'
    : `${restants} en attente`

  return (
    <button
      className="sync"
      onClick={() => void synchroniser()}
      title="Toucher pour réessayer maintenant"
    >
      <i />
      {texte}
    </button>
  )
}
